import { render, staticRenderFns } from "./WheelAlignment.vue?vue&type=template&id=4c6c4ffa&scoped=true&"
var script = {}
import style0 from "./WheelAlignment.vue?vue&type=style&index=0&id=4c6c4ffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6c4ffa",
  null
  
)

export default component.exports